module.exports = __webpack_public_path__ + "img/fabric-product-cym.86fc6aa5.png";